export const messages = {
  en: {
    couponMarket: {
      page: {
        title: 'Coupon Market',
        subtitle: 'Browse and purchase coupons from suppliers',
        loadFailed: 'Failed to load coupon list',
        empty: 'No coupons available'
      },
      list: {
        title: 'Available Coupons'
      },
      supplier: {
        label: 'Supplier',
        all: 'All'
      },
      card: {
        coupon: 'Coupon',
        supplier: 'Supplier',
        businessKey: 'Business No.',
        remark: 'Remark'
      },
      search: {
        placeholder: 'Please enter coupon name',
      },
      price: 'Price',
      buy: 'Buy',
      fetchSupplierError: 'Failed to fetch supplier list',
      fetchCouponError: 'Failed to fetch coupon list'
    }
  },
  zh: {
    couponMarket: {
      page: {
        title: '优惠券商城',
        subtitle: '浏览并购买供应商提供的优惠券',
        loadFailed: '获取优惠券列表失败',
        empty: '暂无可用优惠券'
      },
      list: {
        title: '可购买优惠券'
      },
      supplier: {
        label: '供应商',
        all: '全部'
      },
      card: {
        coupon: '优惠券',
        supplier: '供应商',
        businessKey: '业务编号',
        remark: '备注'
      },
      search: {
        placeholder: '请输入优惠券名称',
      },
      price: '售价',
      buy: '购买',
      fetchSupplierError: '获取供应商列表失败',
      fetchCouponError: '获取优惠券列表失败'
    }
  }
}
